import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { useTranslation } from "react-i18next";
import { CancellationFeesIcon } from "../../general/Icons";

const CancellationFees = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { cancellationFeeAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const cancellationFeeAdjustmentElements = useMemo(() => {
    return cancellationFeeAdjustments?.map(
      ({ adjustment, associatedTaxes }, index) => (
        <AdjustmentItem
          key={`cancellation-fee-${index}`}
          adjustment={adjustment}
          taxes={associatedTaxes}
        />
      )
    );
  }, [cancellationFeeAdjustments]);

  if (!cancellationFeeAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="products-container">
      <div
        className="flex items-center gap-2 mb-2"
        data-testid="products-header"
      >
        <CancellationFeesIcon />
        <h3
          className="text-lg font-medium text-black"
          data-testid="products-title"
        >
          {t("ticketItemsSections.cancellation_fees")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="products-list">
        {cancellationFeeAdjustmentElements}
      </div>
    </div>
  );
};

export default CancellationFees;
